<style>
  .login-container{position:fixed;top: 0%;width:100%;height:100%;background: url("../assets/login.jpg") no-repeat;background-size:cover;}
  .login-container .login-info-box{width:400px;height:330px;padding:30px 50px 30px 50px;position: absolute;top:50%;left:25%;margin-top: -150px;margin-left: -200px;
    -webkit-border-radius: 6px;border-radius: 6px;-moz-border-radius: 6px;border: 1px solid #ffffff;box-shadow: 0 0 25px #cac6c6;-webkit-box-shadow: 0 0 25px #cac6c6;
    background:rgba(255, 255, 255, 0.4);}
  .login-container .height{height:300px}
  .login-container .login-text{margin:0px auto;text-align: left;color: white;margin-bottom: 20px}
  .login-container .img-style{width:24px;height:24px;margin-top:6px;filter: blur(0.5px);}
  .login-container .el-input__inner{height:36px !important;background-color: rgba(255, 255, 255, 0.001);color:black;border-top:none;border-left:none;border-right:none;-webkit-border-radius: 0px;border-radius: 0px;-moz-border-radius: 0px;}
  .login-container .el-form-item{margin-bottom:22px}
  .login-container .btnWidht{width:200px;margin: 0 auto;margin-top: 20px;}
  .login-container .shade-width{width:430px;}
</style>  
<template>
  <div class="login-container">
    <div class="login-info-box" :style="{height:activeName=='1'?'280px':'330px'}">
      <h2 class="login-text">短信平台后台管理系统</h2>
      <el-tabs v-model="activeName"  @tab-click="changeTab(activeName)">
        <el-tab-pane label="账号登录" name="0">
          <el-form :model="loginForm" status-icon :rules="$rules" ref="userLoginForm" class="demo-ruleForm">
            <el-form-item prop="userName">
              <el-input type="text" v-model="loginForm.userName" auto-complete="on" ref="userNameInput" placeholder="请输入用户名">
                <template slot="prefix"><img src="../assets/user.png" class="img-style"></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="userPassword">
              <el-input type="password" v-model="loginForm.userPassword" auto-complete="off" placeholder="请输入密码" maxlength="20">
                <template slot="prefix"><img src="../assets/password.png" class="img-style"></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="codeImg">
              <el-input type="text" class="code" v-model="loginForm.codeImg" auto-complete="off" placeholder="请输入验证码" maxlength="6" @keyup.enter.native="submitForm('userLoginForm')"></el-input>
              <img :src="'data:image/gif;base64,' + imgCode" class="img-code" @click="getImgCode" v-if="imgCode">
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('userLoginForm')" class="btnWidht">登 录</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="短信登录" name="1">
          <el-form :model="msgLoginForm" status-icon :rules="$rules" ref="messageLoginForm" class="demo-ruleForm">
            <el-form-item prop="userPhone">
              <el-input type="text" v-model="msgLoginForm.userPhone" auto-complete="off" placeholder="请输入手机号" maxlength="11" ref="userPhoneInput">
                <template slot="prefix"><img src="../assets/user.png" class="img-style"></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="codeImg">
              <el-input v-model="msgLoginForm.codeImg" auto-complete="off" placeholder="请输入短信验证码" class="code" maxlength="6" @keyup.enter.native="submitForm('messageLoginForm')">
                <template slot="prefix"><img src="../assets/password.png" class="img-style"></template>
              </el-input>
              <span v-show="MsgCodeTextShow" @click="getCode" class="img-code get-code">获取短信验证码</span>
              <span v-show="!MsgCodeTextShow" class="img-code get-code">{{count}} s后可重新获取</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('messageLoginForm')" class="btnWidht">登 录</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="shade-box" v-if="show">
      <div class="shade-content position-top shade-width">
        <p class="dialog-title-bg">请在下方输入正确的验证码
          <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="close('codeForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="loginForm" :rules="$rules" ref="codeForm" label-width="14px" class="demo-ruleForm">
            <el-form-item prop="codeImg">
              <el-input type="text" v-model="loginForm.codeImg" auto-complete="off" placeholder="请输入验证码" maxlength="6" class="code" ref="msgCodeInput" @keyup.enter.native='enterGetCode'></el-input>
              <img :src="'data:image/gif;base64,' + imgCode" class="img-code" @click="getImgCode" v-if="imgCode">
            </el-form-item>
            <el-form-item >
              <el-button type="primary paddingTB7" @click="enterGetCode" :disabled="disabled">确定</el-button>
              <el-button @click="close('codeForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '../server/api' 
  export default {
    data() {
      return {
        activeName: "0",
        imgCode: '',//图片验证码
        show: false,
        disabled: false,
        MsgCodeTextShow: true,
        count: '',//倒计时
        timer: null,//定时器
        loginForm: {
          imagetoken: '',
          userName: '',
          userPassword: '',
          codeImg:'',
        },
        msgLoginForm: {
          userPhone: '',
          codeImg: '',
        },
      };
    },
    created() {
      this.getImgCode();
      this.$nextTick(function(){
        this.$refs.userNameInput.focus();
      })
      // console.log(this.$store.state.loginInfo)
    },
    methods: {
      getImgCode(){//获取图片验证码
        this.loginForm.codeImg = '';
        api.getMsgCode({parms: {}}).then(res => {
          if(res.status == 'success'){
            this.imgCode = res.data.img;
            this.loginForm.imagetoken = res.data.imagetoken;
          }
        })
      },
      changeTab(v){
        if(v == 1){
          // this.$refs.userLoginForm.resetFields();
          this.$nextTick(function(){
            this.$refs.userPhoneInput.focus();
          })
        }else{
          // this.$refs.messageLoginForm.resetFields();
          this.$nextTick(function(){
            this.$refs.userNameInput.focus();
          })
        }
      },
      getCode(){//获取短信验证码
        if(this.msgLoginForm.userPhone){
          if (!/(1[345789]\d{9})/.test(this.msgLoginForm.userPhone)) {
            this.$message.error('手机号不正确！') 
          }else{
            this.show = true;
            this.$nextTick(function(){
              this.$refs.msgCodeInput.focus();
            })
          }
        }else{
          this.$message.error('手机号不能为空！')
        }
      },
      enterGetCode(){
        this.MsgCodeTextShow = false;
        const TIME_COUNT = 60;
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.MsgCodeTextShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
        if(this.loginForm.codeImg){
          this.disabled = true;
          let data = {
            "userPhone": [this.msgLoginForm.userPhone],
            "type": 1,//1.登录 2. 注册 3.修改 4.忘记密码
            "verifyCode": this.loginForm.codeImg,//验证码
            "imagetoken": this.loginForm.imagetoken,//验证码token
          }
          api.getCode({data:data}).then(res =>{
            if(res.status == 'success'){
              this.$message.success('发送成功，请注意查收短信');
              this.close('codeForm')
            }else{
              this.disabled = false;
            }
          })
        }
      },
      close(formName){//取消获取短信验证码
        this.$refs[formName].resetFields();
        this.show = false;
      },
      submitForm(formName) {//登录
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.timer){
              clearInterval(this.timer);
              this.timer = null;
            }
            let data = {
              "userName": this.loginForm.userName,
              "userPassword": this.$md5(this.$md5(this.loginForm.userPassword)),
              "loginType": this.activeName,//0 密码登录 1 短信登录
              "imagetoken": this.loginForm.imagetoken,//图片验证码token
              "verifyCode": this.loginForm.codeImg,//图形验证码
              "msgCode": this.msgLoginForm.codeImg,//短信验证码
              "userPhone": this.msgLoginForm.userPhone,
            }
            api.login({data:data}).then(res =>{
              if(res.status == 'success'){
                this.$store.state.loginInfo = res.data;
                // this.$store.actions.loginAction();
                localStorage.setItem('USER', JSON.stringify(res.data));
                
                // console.log(this.$store.actions.loginAction)
                this.$router.push({ path: '/message' })
              }else{
                if(res.msg == '验证码错误/已失效，请重新输入！'){
                  this.getImgCode();
                }
              }
            });
          } else {
            return false;
          }
        });
      },
    }
  }
</script> 





// WEBPACK FOOTER //
// src/view/login.vue